module.exports = __webpack_public_path__ + "3d45e9938c4c044eb0518b346ce815e6.svg";